import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Card, TextInput, Title, Modal, Button } from "@mantine/core";

import { GeospotForm, GeospotList } from "./";
import { ActionBar } from "@components/shared";

export default function GeospotManagement({ locationId }) {
  const [createVisible, setCreateVisible] = useState(false);
  const [items, setItems] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const CancelToken = axios.CancelToken;
  const cancelRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, [searchValue]);

  function fetchData() {
    const req = {
      location_id: locationId,
      search_value: searchValue,
    };

    const cancel = cancelRef.current;
    if (cancel) {
      cancel();
    }

    axios
      .post(`/retrieve-geo-spots/`, req, {
        cancelToken: new CancelToken(function executor(c) {
          cancelRef.current = c;
        }),
      })
      .then(({ data }) => {
        setItems(data.response);
      })
      .catch((err) => {
        setItems([]);
      });
  }

  return (
    <div>
      <Modal
        opened={createVisible}
        onClose={() => setCreateVisible(false)}
        title="Create Geo-Spot"
      >
        <GeospotForm
          locationId={locationId}
          onSuccess={() => {
            setCreateVisible(false);
            fetchData();
          }}
        />
      </Modal>
      <div>
        <ActionBar color="violet">
          <Button
            radius="md"
            color="violet"
            onClick={() => setCreateVisible(true)}
          >
            Create Geo-Spot
          </Button>
        </ActionBar>
        <TextInput
          placeholder="Search for a geospot..."
          size="lg"
          my="md"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <GeospotList items={items} fetchData={fetchData} />
      </div>
    </div>
  );
}
